(function () {
  'use strict';

  var mobile_nav_initialized = false;

  Drupal.behaviors.utility_menu_mobile = {
    attach: function (context, settings) {

      if (mobile_nav_initialized) {
        return;
      }

      var $utility_menu_mobile = jQuery('[id="block-utilitymenu"]');

      var $button_toggle_menu = $utility_menu_mobile.find('a[href="#toggle-menu-mobile"]');
      var $button_toggle_search = $utility_menu_mobile.find('a[href="#toggle-search-mobile"]');

      // Other elements
      var $navbar_collapse = jQuery('.navbar-collapse');
      var $block_search = jQuery('.acg-search-form');
      var $search_input = $block_search.find('input[type="search"]');

      function query_is_search_active() {
        return $block_search.hasClass('in');
      }

      function query_is_menu_active() {
        return $navbar_collapse.hasClass('in');
      }

      function show_search() {
        hide_menu();
        $button_toggle_search.addClass('toggle-is-active');
        $block_search.addClass('in');
      }

      function hide_search() {
        $button_toggle_search.removeClass('toggle-is-active');
        $block_search.removeClass('in');
      }

      function show_menu() {
        hide_search();
        $button_toggle_menu.addClass('toggle-is-active');
        $navbar_collapse.addClass('in');
      }

      function hide_menu() {
        $button_toggle_menu.removeClass('toggle-is-active');
        $navbar_collapse.removeClass('in');
      }


      function action_toggle_search(event) {
        event.preventDefault();

        // Toggle on
        if (!query_is_search_active()) {
          show_search();
          $search_input.focus();
        }
        // Toggle off
        else {
          $search_input.blur();
          hide_search();
        }
      }

      function action_toggle_menu(event) {
        event.preventDefault();

        // Toggle on
        if (!query_is_menu_active()) {
          show_menu();
        }
        // Toggle off
        else {
          hide_menu();
        }
      }

      $button_toggle_menu.on('click', action_toggle_menu);
      $button_toggle_search.on('click', action_toggle_search);

      mobile_nav_initialized = true;
    }
  };
})(jQuery);
